/* This file is autogenerated, see readme.md for instructions */
import FastForwardSvgIcon from '@bloomreach/banana-theme/icons/fast-forward.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FastForwardIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FastForwardSvgIcon />
    </Icon>
  );
});

FastForwardIcon.displayName = 'FastForwardIcon';

export default FastForwardIcon;
